export default __webpack_public_path__ + "static/media/JavaScript(ES6)-Logo.a309520a.svg";